import React, { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { getCils, hideCil } from "../../api/cils";
import LoadingPage from "../Loading/loading";
import { useNavigate } from "react-router-dom";
import { Cookies } from "react-cookie";

const CilComponent = (props) => {
  const navigate = useNavigate();
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [searchTerm, setSearchTerm] = useState("");
  const [cils, setCils] = useState(null);
  const [cilsFinal, setCilsFinal] = useState(null);
  const [hideId, setHideId] = useState("");
  useEffect(() => {
    setCils(null);
    setCilsFinal(null);
    cilGet();
  }, []);

  const cilGet = async (id) => {
    getCils(props.cilType).then((result) => {
      setCils(result.data.response);
      setCilsFinal(result.data.response);
    });
  };

  const hide = async (id) => {
    await hideCil(id).then((result) => {
      cilGet();
      setHideId("");
    });
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value) {
      setCilsFinal(
        cils.filter(
          (cil) =>
            cil.user_id.name.toLowerCase().includes(value.toLowerCase()) ||
            cil.user_id.phone.toLowerCase().includes(value.toLowerCase()),
        ),
      );
    } else {
      setCilsFinal(cils);
    }
  };

  return (
    <>
      {cilsFinal === null ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="search-container">
            <div className="search-input-wrapper">
              <FiSearch className="search-icon" />
              <input
                type="text"
                placeholder="Name or Phone number"
                value={searchTerm}
                onChange={handleSearch}
                className="search-input"
              />
            </div>
          </div>

          <div>Number of CIL is {cilsFinal.length}</div>

          <div className="card-cards">
            {cilsFinal?.map((cil) => (
              <div key={cil._id} className={`card-card`}>
                <div className="card-info">
                  <div>
                    <p className="line">
                      <span className="label">Broker name:</span>{" "}
                      {cil?.user_id?.name}
                    </p>
                    <p className="line">
                      <span className="label">Broker phone:</span>{" "}
                      {cil?.user_id?.phone}
                    </p>
                    <p className="line">
                      <span className="label">Project name:</span>{" "}
                      {cil?.project_name}
                    </p>
                    <p className="line">
                      <span className="label">Sales name:</span>{" "}
                      {cil?.sales_name}
                    </p>
                    <p className="line">
                      <span className="label">Sales phone:</span>{" "}
                      {cil?.sales_phone}
                    </p>
                    <p className="line">
                      <span className="label">Admin code:</span>{" "}
                      {cil?.admin_code}
                    </p>
                    <p className="line">
                      <span className="label">Create at:</span>{" "}
                      {cil?.createdAt.split("T")[0]}
                    </p>
                    {hideId === cil._id && (
                      <div
                        style={{
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          padding: "5px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <p className="line">
                          Are you sure you want to delete this?{" "}
                        </p>
                        <div className="card-info">
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                setHideId("");
                              }}
                              className="action-btn accept-btn"
                            >
                              No
                            </button>
                          </div>
                          <div className="card-actions">
                            <button
                              onClick={() => {
                                hide(cil._id);
                              }}
                              className="action-btn remove-btn"
                            >
                              Yes
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <button
                    onClick={() => {
                      navigate(`/cil/${cil.status.toLowerCase()}/${cil._id}`);
                    }}
                    className="action-btn ban-btn"
                  >
                    View
                  </button>
                  <div style={{ height: "10px" }}></div>
                  {isSuper &&
                    hideId === "" &&
                    (props.cilType === "Accept" ||
                      props.cilType === "Reject") && (
                      <button
                        onClick={() => {
                          setHideId(cil._id);
                        }}
                        className="action-btn remove-btn"
                      >
                        Delete
                      </button>
                    )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default CilComponent;
